import { AxiosRequestConfig } from 'axios'

import {
  ParkingConfigFormPayload,
  SetParkingConfigActivePayload,
  UpdateParkingConfigData,
} from './types'

const appendFormPayload = (payload: FormData, data: ParkingConfigFormPayload) => {
  const {
    parkingType,
    externalTicket,
    qrSystemId,
    qrIssuerId,
    qrBenefitId,
    unlockAmount,
    unlockMode,
    allTagsRequired,
    isFree,
    validFrom,
    validTo,
    active,
    title,
    shortTitle,
    description,
    additionalText,
    tagIds,
    storeIds,
    levels,
    icon,
    image,
  } = data

  payload.append('parkingType', parkingType)
  payload.append('externalTicket', String(!!externalTicket))
  if (externalTicket) {
    if (qrSystemId) payload.append('qrSystemId', qrSystemId)
    if (qrIssuerId) payload.append('qrIssuerId', qrIssuerId)
    if (qrBenefitId != null) payload.append('qrBenefitId', String(qrBenefitId))
  }
  if (unlockAmount != null) payload.append('unlockAmount', String(unlockAmount))
  if (unlockMode) payload.append('unlockMode', unlockMode)
  payload.append('allTagsRequired', allTagsRequired.toString())
  payload.append('isFree', String(!!isFree))
  payload.append('validFrom', validFrom ?? '')
  payload.append('validTo', validTo ?? '')
  payload.append('active', active.toString())
  payload.append('title', title)
  payload.append('shortTitle', shortTitle)
  if (description) payload.append('description', description)
  payload.append('additionalText', additionalText ?? '')
  // Always send lists so an empty clear is distinguishable from "omit / keep previous"
  // on update (multipart missing keys are undefined on the server).
  payload.append('tagIds', tagIds.join(','))
  payload.append('storeIds', storeIds.join(','))
  payload.append('levels', JSON.stringify(levels))
  if (icon) payload.append('icon', icon)
  if (image) payload.append('image', image)
}

const getParkingConfigs = (): AxiosRequestConfig => ({
  url: '/parking-configs',
  method: 'GET',
})

const createParkingConfig = (data: ParkingConfigFormPayload): AxiosRequestConfig => {
  const payload = new FormData()
  appendFormPayload(payload, data)

  return {
    url: '/parking-configs',
    method: 'POST',
    data: payload,
  }
}

const updateParkingConfig = ({
  id,
  payload: data,
}: UpdateParkingConfigData): AxiosRequestConfig => {
  const payload = new FormData()
  appendFormPayload(payload, data)

  return {
    url: `/parking-configs/${id}`,
    method: 'PUT',
    data: payload,
  }
}

const deleteParkingConfig = (id: number): AxiosRequestConfig => ({
  url: `/parking-configs/${id}`,
  method: 'DELETE',
})

const setParkingConfigActive = ({
  id,
  active,
}: SetParkingConfigActivePayload): AxiosRequestConfig => ({
  url: `/parking-configs/${id}/active`,
  method: 'PATCH',
  data: { active },
})

const getParkingDisplayOrder = (): AxiosRequestConfig => ({
  url: '/v2/memberships',
  method: 'GET',
})

const updateParkingDisplayOrder = (payload: {
  membershipId: number
  prizeIds: number[]
}): AxiosRequestConfig => ({
  url: `/memberships/${payload.membershipId}/order`,
  method: 'PUT',
  data: { prizes: payload.prizeIds },
})

export {
  getParkingConfigs,
  createParkingConfig,
  updateParkingConfig,
  deleteParkingConfig,
  setParkingConfigActive,
  getParkingDisplayOrder,
  updateParkingDisplayOrder,
}
